import { ControlProperty } from '../../../../../common/models';
import { Validators } from '@angular/forms';
import { TransportPlannerProfileFilterModel } from '../../transport/models';
import { PlannerProfileType } from '../../../../constants';
import { mustNotBeBlankValidator } from '../../../../../common/utils';

export class TransportPlannerProfileDetails {
  id?: number;
  createdBy?: number;
  createdByEmail?: string;
  name: string;
  description: string;
  type: PlannerProfileType = PlannerProfileType.Public;

  constructor(params?: TransportPlannerProfileDetails) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class TransportPlannerProfileModel extends TransportPlannerProfileDetails {
  filter: TransportPlannerProfileFilterModel = new TransportPlannerProfileFilterModel();

  constructor(params?: TransportPlannerProfileModel) {
    super();
    if (params) {
      Object.assign(this, params);
      this.filter = new TransportPlannerProfileFilterModel(params.filter);
    }
  }
}

export class TransportPlannerProfileDetailsForm {
  id?;
  createdBy?;
  createdByEmail?;
  constructor(
    model: TransportPlannerProfileDetails,
    public name: ControlProperty<string> = [model.name, [Validators.required, mustNotBeBlankValidator]],
    public description: ControlProperty<string> = [model.description, []],
    public type: ControlProperty<PlannerProfileType> = [model.type, [Validators.required]],
  ) {
    if (model.id) {
      this.id = [model.id, []];
    }
    if (model.createdBy) {
      this.createdBy = [model.createdBy, []];
    }
    if (model.createdByEmail) {
      this.createdByEmail = [model.createdByEmail, []];
    }
  }
}
